<template>
  <div></div>
  <!-- <div class="gps-container">
    <h3>GPS 定位信息</h3>
    <div v-if="isLoading"
         class="loading">定位中...</div>

    <div v-if="positionInfo"
         class="position-info">
      <p>纬度：{{ positionInfo.latitude }}</p>
      <p>经度：{{ positionInfo.longitude }}</p>
      <p>精度（米）：{{ positionInfo.accuracy }}</p>
      <p>获取时间：{{ positionInfo.timestamp | formatTime }}</p>

      <div v-if="isGeoLoading"
           class="loading small">解析地址中...</div>
      <div v-if="addressInfo"
           class="address-info">
        <p>📍 解析地址：{{ addressInfo.formatted_addresses }}</p>
        <p>省：{{ addressInfo.province }}</p>
        <p>市：{{ addressInfo.city }}</p>
        <p>区：{{ addressInfo.district }}</p>
        <p>街道：{{ addressInfo.street }}</p>
      </div>
      <div v-if="geoErrorMsg"
           class="error-msg small">{{ geoErrorMsg }}</div>
    </div>

    <div v-if="errorMsg"
         class="error-msg">{{ errorMsg }}</div>
  </div> -->
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GPSLocation',
  data() {
    return {
      isLoading: false, // 定位加载状态
      positionInfo: null, // 存储定位信息
      errorMsg: '', // 定位错误信息
      watchId: null, // 监听位置变化的ID
      isGeoLoading: false, // 逆地理编码加载状态
      addressInfo: null, // 解析后的地址信息
      geoErrorMsg: '' // 逆地理编码错误信息
    }
  },
  filters: {
    // 时间戳格式化过滤器
    formatTime(timestamp) {
      return new Date(timestamp).toLocaleString()
    }
  },
  // 组件挂载后立即执行定位
  mounted() {
    this.getGPSInfo()
  },
  methods: {
    // 核心方法：获取当前定位（腾讯前端定位组件），高精度优先
    getGPSInfo() {
      // 检查腾讯前端定位组件是否已加载
      if (!window.LBS || !window.LBS.WebComponent || !window.LBS.WebComponent.Geolocation) {
        this.errorMsg = '腾讯定位组件未加载，请刷新页面重试'
        this.isLoading = false
        return
      }
      // 先尝试高精度定位
      this.requestLocation(true)
    },

    // 调用定位组件获取当前位置
    requestLocation(highAccuracy) {
      this.isLoading = true
      this.errorMsg = ''
      this.positionInfo = null
      this.addressInfo = null
      this.geoErrorMsg = ''

      const geoInstance = new window.LBS.WebComponent.Geolocation({
        key: 'W7SBZ-L6QKA-C3IKU-CGFZZ-CWVTO-G4F7K',
        referer: 'bos-client'
      })

      geoInstance.getLocation(
        (result) => this.handleLocationSuccess(result),
        (error) => this.handleLocationError(error, highAccuracy),
        {
          timeout: 10000, // 超时时间10秒
          highAccuracy, // 严格高精度定位（失败时不走 IP 兜底）
          maximumAge: 0 // 不使用缓存，每次都获取新位置
        }
      )
    },

    // 定位成功：组件已返回地址信息与 GCJ02 坐标（h5 定位已由组件内部转坐标），直接使用
    handleLocationSuccess(result) {
      this.isLoading = false
      console.log('腾讯定位组件返回：', result)
      this.positionInfo = {
        latitude: result.lat, // 纬度（GCJ02）
        longitude: result.lng, // 经度（GCJ02）
        accuracy: result.accuracy, // 定位精度（米）
        type: result.type, // 定位方式（h5/qq/x5/ip 等）
        timestamp: Date.now()
      }

      // 将定位结果写入 store，供打卡界面展示与提交
      this.signCheckLocation.lat = result.lat
      this.signCheckLocation.lng = result.lng
      this.signCheckLocation.address = result.addr || result.address || ''
      this.signCheckLocation.country = result.nation || ''
      this.signCheckLocation.province = result.province || ''
      this.signCheckLocation.city = result.city || ''
      this.signCheckLocation.district = result.district || ''
      this.signCheckLocation.type = result.type
      this.signCheckLocation.accuracy = result.accuracy
    },

    // 定位失败：高精度失败时弹出提示，可选择降级重试（error.status 为 PositionStatus 定位状态码）
    handleLocationError(error, highAccuracy) {
      this.isLoading = false
      console.error('腾讯定位组件失败：', error)
      const msgMap = {
        10001: '所有定位方式均失败，请检查定位权限后重试',
        10002: '所有定位方式均超时，请重试',
        10101: '未获取到定位权限，请在浏览器设置中允许定位后重试',
        10103: '定位超时，请重试',
        10501: 'IP定位失败',
        10601: '地址解析服务异常',
        10602: '坐标转换服务异常'
      }
      const message = error.message || msgMap[error.status] || '定位失败，请检查网络或定位权限'
      this.errorMsg = message

      // 高精度定位失败：弹窗提示，用户可选择降级为普通模式重新定位
      if (highAccuracy) {
        this.$dialog.confirm({
          title: '定位提示',
          message: '高精度定位失败，是否使用普通模式重新定位？',
          confirmButtonText: '重新定位',
          cancelButtonText: '取消'
        }).then(() => {
          this.requestLocation(false)
        }).catch(() => {
          this.$toast(message)
        })
      } else {
        this.$toast(message)
      }
    },

    stopWatchGPS() {
      if (this.watchId) {
        navigator.geolocation.clearWatch(this.watchId)
        this.watchId = null
      }
    }
  },
  computed: {
    ...mapState('loacationAbout', ['signCheckLocation'])
  },
  beforeDestroy() {
    this.stopWatchGPS()
  }
}
</script>

<style scoped>
.gps-container {
  padding: 20px;
}
.loading {
  margin-top: 10px;
  color: #666;
}
.loading.small {
  margin-top: 5px;
  font-size: 14px;
}
.position-info {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.address-info {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ddd;
}
.error-msg {
  margin-top: 20px;
  color: red;
}
.error-msg.small {
  margin-top: 5px;
  font-size: 14px;
}
</style>
